import { Button } from '@/ui/button/button';
import { Flexbox } from '@/ui/flexbox/flexbox';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';
import { useTranslation } from 'react-i18next';
import { usePendingCompaniesCount } from '../../pending-companies/use-pending-companies-count.query';

export const PendingCompaniesCounter = () => {
  const { hasRequiredPermission } = useUserPermissions();
  const { t } = useTranslation('projects', { keyPrefix: 'projectOverview' });
  const { data: pendingCompaniesCount } = usePendingCompaniesCount();
  const hasViewPendingCompaniesPermission = hasRequiredPermission(
    PERMISSION.VIEW_PENDING_COMPANIES,
  );

  if (
    !hasViewPendingCompaniesPermission ||
    pendingCompaniesCount?.pendingCompanies === undefined ||
    pendingCompaniesCount.pendingCompanies < 0
  ) {
    return null;
  }

  const count = pendingCompaniesCount.pendingCompanies;
  const displayCount = count === 0 ? '0' : String(count).padStart(2, '0');

  return (
    <Flexbox fullWidth justify="flex-end">
      <Button variant="alert" data-testid="pending-companies-counter">
        {displayCount} {t`pendingCompanies`}
      </Button>
    </Flexbox>
  );
};
